import * as $ from 'jquery';
$(document).on( 'click', '.admin .side-dropdown .dropdown-item', function () {
    $(".admin .side-dropdown .dropdown-item").removeClass('active');
	$(this).addClass('active');
 }); 
 $(document).on( 'click', '.admin .side-dropdown', function () {
    $(".admin .side-dropdown").removeClass('opened');
	$(this).addClass('opened');
    
 }); 


//  For mobile menu toggle
  $(document).on( 'click', '#mobileMenubar', function () {
    // console.log("pageUrl", location.href);
    $(".profile-wrapper .sider-wrapper").css({
        position: "absolute",
        zIndex: 1
    }).fadeIn(200);    
 }); 